import React, { useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  BASE_BREADCRUMB_NODE,
  CATALOGUE_NODE,
  POINTING_NODE,
} from "../../constants";
import { AppContext } from "../../context/appContext";
import { isEmptyString } from "../../helperFunc";
import {
  useGetPointingSourcesByCatalogueIdQuery,
  useGaussDownloadMutation
} from "../../redux/pointingSourcesService";

import {
  breadcrumbNodesUpdated,
  filtersUpdated,
  selectedSPWUpdated,
  spwFilterUrlUpdated,
} from "../../redux/reducer";
import CatalogueDataSection from "../CatalogueDataSection/CatalogueDataSection";


function PointingSourcesView() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { pointingId } = useParams();
  let { catalogueMetadataId } = useParams();
  const { toggleLoaderVisibility } = useContext(AppContext);
  const { selectedSPW } = useSelector((state) => state.router);
  const [gaussDownloadPost] = useGaussDownloadMutation();
  let { currentData, isFetching } = useGetPointingSourcesByCatalogueIdQuery(
    {
      pointingId: pointingId || null,
      spw:
        isEmptyString(selectedSPW) || selectedSPW === "ALL"
          ? null
          : selectedSPW,
          catalogueId:catalogueMetadataId

    },
    {
      skip: isEmptyString(selectedSPW) || !pointingId,
    }
  );

  function navigateSourceTo(urlId) {
    navigate(`../catalogue/${catalogueMetadataId}/source-detail/${encodeURIComponent(urlId)}`, {
      // state: { internalNavigation: location?.state?.internalNavigation || "pointingsRefreshed" },
      state: { internalNavigation: location?.state?.internalNavigation ,pointingsRefreshed:!location?.state?.internalNavigation },
    });
    dispatch(filtersUpdated({ filters: {} }));
    dispatch(selectedSPWUpdated({ selectedSPW: "" }));
    dispatch(spwFilterUrlUpdated({ spwFilterUrl: { base_url: "", id: "", catalogue_id: "" } }));
  }

  useEffect(() => {
    if (isFetching) {
      toggleLoaderVisibility(true);
    } else {
      toggleLoaderVisibility(false);
    }
  }, [isFetching]);

  useEffect(() => {
    let spwFilterUrlValues = { base_url: "pointing", id: pointingId, catalogue_id: catalogueMetadataId };
    dispatch(spwFilterUrlUpdated({ spwFilterUrl: spwFilterUrlValues }));
    if (!location?.state?.internalNavigation) {
      dispatch(
        breadcrumbNodesUpdated({
          breadcrumbNodes: [...BASE_BREADCRUMB_NODE, ...POINTING_NODE],
        })
      );
    } else {
      dispatch(
        breadcrumbNodesUpdated({
          breadcrumbNodes: [
            ...BASE_BREADCRUMB_NODE,
            ...CATALOGUE_NODE,
            ...POINTING_NODE,
          ],
        })
      );
    }
  }, []);

  return (
    <>
      <CatalogueDataSection
        data={currentData}
        navigateSourceTo={navigateSourceTo}
        gaussDownloadPost={(sourceIds) => gaussDownloadPost({
          pointingId: pointingId || null,
          sourceIds: {source_ids: sourceIds},
          catalogueId:catalogueMetadataId
        })}
      />
    </>
  );
}

export default PointingSourcesView;
